import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { LucideAngularModule, X } from 'lucide-angular';

export interface PrototypeSelectOption {
  value: number | string | null;
  label: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-prototype-select',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, LucideAngularModule],
  templateUrl: './prototype-select.component.html',
  styleUrls: ['./prototype-select.component.scss']
})
export class PrototypeSelectComponent {
  readonly clearIcon = X;

  @Input() label = '';
  @Input() placeholder = 'Selecione';
  @Input() required = false;
  @Input() disabled = false;
  @Input() clearable = true;
  @Input() value: number | string | null = null;

  ngOnChanges(): void {
    // Valor fora das opções: limpa (evita select branco). Emitir síncrono aqui
    // causaria NG0100 (mesmo ciclo de CD); adia pro próximo microtask.
    if (this.value !== null && this.value !== undefined && !this.options.some(opt => opt.value === this.value)) {
      Promise.resolve().then(() => {
        this.value = null;
        this.valueChange.emit(null);
      });
    }
  }
  @Input() options: PrototypeSelectOption[] = [];

  @Output() valueChange = new EventEmitter<number | string | null>();

  get hasValue(): boolean {
    return this.value !== null && this.value !== undefined && this.value !== '';
  }

  trackByValue(_index: number, option: PrototypeSelectOption): number | string | null {
    return option.value;
  }

  onSelectionChange(value: number | string | null): void {
    this.valueChange.emit(value);
  }

  clearValue(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.valueChange.emit(null);
  }

  stopMouseDown(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }
}